<template>
  <div id="app" :class="'page-' + $router.currentRoute.name">
    <el-container v-if="currentUser">
      <vue-progress-bar></vue-progress-bar>
      <el-header id="header">
        <router-link :to="'/home'" class="home-link">
          <img class="logo" src="./assets/icon.png">
          <h1>Charles</h1>
        </router-link>
        <div class="page-title">{{ pageTitle }}</div>
      </el-header>
    </el-container>
    <el-container id="main-container">
      <el-aside class="main-sidebar" :width="'200px'" v-if="currentUser">
        <navbar />
      </el-aside>
      <el-main id="main" v-if="!isLoggedIn || currentUser">
        <router-view />
      </el-main>
      <el-main id="main" v-else v-loading="true">
      </el-main>
      <div class="version-number">v{{ version }}</div>
    </el-container>
  </div>
</template>

<script>
var pjson = require('../package.json')
import Navbar from './components/Navbar'

export default {
  name: 'app',
  components: {
    Navbar
  },
  data () {
    return {
      version: pjson.version,
      changelogShown: false
    }
  },
  created () {
    if (this.isLoggedIn) {
      // Download some common endpoints for the rest of the app to use
      this.$store.dispatch('getCurrentUser')
      this.$store.dispatch('getUsers')
      this.$store.dispatch('getTags')
    }
  },
  methods: {
    showChangelog () {
      if (this.currentUser && !this.changelogShown && this.$store.state.lastChangelogDismissed !== this.version) {
        let message = pjson.changelog[this.version]
        if (message) {
          this.changelogShown = true
          let _this = this
          this.$notify.info({
            title: 'Charles v' + this.version,
            dangerouslyUseHTMLString: true,
            message: message,
            duration: 0,
            onClose () {
              _this.$store.dispatch('dismissChangelog', _this.version)
              _this.changelogShown = false
            }
          })
        }
      }
    }
  },
  computed: {
    pageTitle () {
      return this.$store.state.pageTitle
    },
    currentUser () {
      return this.$store.state.users.currentUser
    },
    isLoggedIn () {
      return !!this.$store.state.accessToken
    }
  },
  mounted () {
    this.showChangelog()
  },
  watch: {
    'currentUser' () {
      this.showChangelog()
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  .version-number {
    position: fixed;
    bottom: 0;
    left: 13px;
    font-size: 9px;
    z-index: 4;
  }
#app {
  min-height: 100vh;
  background-color: #E4E4E4;

  &.page-login {
    background-color: #FFF;
  }
}
h1, h2, h3, h4, h5 {
  margin: 0;
}
#main {
  flex-basis: 0;
  padding: 0;
  .el-header {
    background-color: #FFF;
    box-shadow: 2px 0 6px #AAA;
    z-index: 2;
  }
}
#main-container {
  min-height: ~'calc(100vh - 60px)';
}

.main-sidebar {
  overflow: hidden;
  box-shadow: 2px 2px 4px #E4E4E4;
  z-index: 3;
  @media screen and (max-width: 767px) {
    width: 55px !important;

    li {
      .fa-icon {
        margin-right: 20px !important;
      }
    }
  }
}

.panels {
  padding: 10px;
  @media screen and (max-width: 767px) {
    padding: 5px;
  }

  > .panel {
    padding: 10px;
    @media screen and (max-width: 767px) {
      padding: 5px;
    }
  }
  @media screen and (min-width: 1020px) {
    display: flex;
  }
}
.panel {
  width: 100%;

  @media screen and (min-width: 1020px) {
    flex: 1;
    &.panel-left {
      // margin-right: 15px;
      order: 1;
    }
    &.panel-right {
      // margin-left: 15px;
      order: 2;
    }
    &.panel-left,
    &.panel-right {
      // margin-bottom: 15px;
      width: ~"calc(50% - 45px)";
    }
    &.panel-full-width {
      order: 3;
      width: 100%;
      max-width: 100%;
    }
  }
  @media screen and (min-width: 1020px) {
    margin-left: auto;
    margin-right: auto;
  }
}

.dashboard,
.wip,
.projects,
.clients,
.users,
.app-builds,
.reports {
  .el-main {
    max-height: ~'calc(100vh - 120px)';
    @media screen and (max-width: 767px) {
      padding: 10px;
    }
  }

  @media screen and (max-width: 960px) {
    .el-header {
      padding: 0 10px;
      .card-title{
        display: none;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .el-header {
      padding: 0 10px;
      .card-title,
      .el-radio-group {
        display: none;
      }

      .search-bar {
        max-width: 100%;
        width: ~'calc(100% - 50px)';
        margin-right: 0;
        float: none;
      }
    }
  }
}
.project,
.client,
.task,
.user {
  .el-main {
    max-height: ~'calc(100vh - 200px)';
  }
  .el-header {
    .client-code {
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  @media screen and (max-width: 767px) {
    .el-header.with-tags {
        height: 60px !important;
      .card-title {
        overflow: hidden;
        width: ~'calc(100% - 50px)';
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .el-main {
      max-height: ~'calc(100vh - 120px)';
    }
  }
}
.user,
.client {
  .el-main {
    max-height: ~'calc(100vh - 165px)';
  }
}
.dashboard,
.wip {
  @media screen and (max-width: 767px) {
    .el-header {
      display: none;
    }
    .el-main {
      max-height: ~'calc(100vh - 60px)';
      padding: 5px;
    }
  }
}

.dashboard {

}

.list-panel {
  .el-card__header {
    margin: 0 2px;
    border-bottom: 1px solid #E4E4E4;
  }
  .el-card {
    margin-bottom: 10px;
    border-radius: 10px;
  }
  .el-card__body {
    padding: 0;
  }
}
.list-group {
  padding: 10px 8px 0 8px;

  &:last-child {
    padding-bottom: 10px;
  }

  .el-button+.el-button {
    margin-left: 0;
  }
}

.list-item {
  border: 1px solid #e6e6e6;
  box-shadow: 0 2px 5px #e6e6e6;
  background-color: #FFF;
  border-radius: 5px;
  margin-bottom: 8px;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  transition: box-shadow 0.3s;
  width: 100%;

  &.el-button {
    color: #303133;
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    line-height: 20px;
    font-size: 14px;
    letter-spacing: .01em;
    > span {
      width: 100%;
    }
    b {
      font-size: 0.9em;
    }
  }



  &:last-child {
    margin-bottom: 0;
  }

  &.draggable {
    cursor: grab;
  }

  @media screen and (max-width: 520px) {
    padding: 10px 15px;
    .client-code {
      margin-right: 10px;
    }
  }
}
.list-item-btn {
  display: flex;
  text-align: left;
  flex-direction: row;
  width: 100%;
  align-items: center;

  .info {
    flex: 1;
    white-space: normal;
    line-height: 1.2em;
    padding-right: 10px;
  }
  .icon {
    justify-self: flex-end;
  }
  .code,
  .created-at {

    font-size: 0.9em;
  }

}

#header {
  color: #333;
  background: #FFF;
  .home-link {
    color: #000;
    text-decoration: none;
    display: inline-block;
  }
  .logo {
    width: 30px;
    height: auto;
    border-radius: 50px;
    vertical-align: middle;
    display: inline-block;
    margin-bottom: 3px;
    position: relative;
    z-index: 1;
  }
  h1 {
    vertical-align: middle;
    display: inline-block;
    margin-left: 10px;
    font-size: 1.4rem;
  }
  .page-title {
    float: right;
  }
}

.header-btn {
  margin-top: 10px;
}
.tags {
  .el-tag {
    margin: 0 1px;
  }
}
.el-header {
  border-bottom: 1px solid #e6e6e6;
  width: 100%;
  line-height: 60px;

  &.with-tags {
    height: auto !important;
    padding-bottom: 7px;
    .el-tag {
      margin-bottom: 8px;
    }
    .tags {
      line-height: initial;
      .fa-icon {
        height: 1em;
        width: auto;
        margin-right: 4px;
        margin-bottom: 1px;
        vertical-align: middle;
      }
    }
    .header-btn,
    .search-bar {
      margin-top: 28px;
    }
    .search-bar {
      line-height: 1em;
    }
  }
  @media screen and (max-width: 960px) {
    .tags {
      display: none;
    }
    .header-btn {
      padding: 8px;
      i {
        font-size: 20px;
      }
      span {
        display: none;
      }
    }
    &.with-tags {
      padding-bottom: 0;
      .header-btn,
      .search-bar {
        margin-top: 10px;
      }
    }
  }
}
.el-card {
  background-color: #F2F2F2;
}
.el-card__header {
  .el-button.pull-right {
    @media screen and (max-width: 767px) {
      padding: 0;
      margin-top: -2px;
      i {
        font-size: 24px;
      }
      span {
        display: none;
      }
    }
  }
}
.timer {
  color: #606266;
  .fa-icon {
    width: 1.3em;
    height: auto;
    margin-left: 10px;
    margin-right: 5px;
    vertical-align: middle;
  }
  .total-time {
    display: inline-block;
    vertical-align: middle;
  }
}
.card-title {
  display: inline-block;
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}

.router-link {
  color: #000;
  text-decoration: none;
}
.search-bar {
  margin-right: 20px;
  max-width: 180px;
  .search-input {
    width: 100%;
    height: 30px;
    border: none;
    padding: 4px 8px;
  }
}

.list-group {
  h3 {
    color: #606266;
    font-size: 0.9rem;
    margin-bottom: 2px;
    margin-left: 2px;
  }
}

// Element Uploader
  .icon-uploader {
    width: 120px;
    height: 120px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &.circular {
      border-radius: 60px;
    }

    .icon-uploader.uploaded {
      border: 1px solid #67c23a;
    }

    .icon-uploader:hover {
      border-color: #409EFF;
    }
    .el-upload-dragger {
      width: 120px;
      height: 120px;
      border: none;
    }
    .icon-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
    }
    .icon {
      width: 100%;
      height: auto;
      display: block;
    }
  }


// Mixins
.clearfix() {
  &:before,
  &:after {
    content: "";
    display: table;
  }
  &:after {
    clear: both;
  }
}

.clearfix {
  .clearfix();
}

// Reset
* {
  box-sizing: border-box;
  font-family: 'Lato', sans-serif;
}

html, body {
  padding: 0;
  margin: 0;
  font-weight: 400;
  line-height: 20px;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  letter-spacing: .01em;

}

a {
  color: #303133;
  text-decoration: none;
}

h2 {
  font-size: 1.2rem;
}
h3 {
  font-size: 1.1rem;
}

@keyframes activeTask {
  0% {
    color: #EDEDED;
  }
  30% {
    color: #EDEDED;
  }
  40% {
    color: #f44336;
  }
  90% {
    color: #f44336;
  }
  100% {
    color: #EDEDED;
  }
}
.active-task {
  animation: activeTask 1.3s infinite;
}
</style>
